import Vue from 'vue'
import Vuex from 'vuex'

import OpportunityStore from './stores/OpportunityStore'
import SectorStore from './stores/SectorStore'
import RegionStore from './stores/RegionStore'
import NearbyInfrastructureStore from './stores/NearbyInfrastructureStore'
import TemplateStore from './stores/TemplateStore'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		OpportunityStore,
		SectorStore,
		RegionStore,
		NearbyInfrastructureStore,
		TemplateStore
	}
})

export default store